
const TEMPLATES_UPDATED = (state, templates) => {
  state.templates = templates
}

const TEMPLATE_UPDATED = (state, template) => {
  state.template = template
  state.size = template.size
}

const PAGINATION_UPDATED = (state, { page, total }) => {
  state.pagination.currentPage = total > 0 ? Number(page) : 1
  state.pagination.totalItems = total
}

const SECTIONS_UPDATED = (state, sections) => {
  state.sections = sections
}

const SECTION_UPDATED = (state, section) => {
  state.section = JSON.parse(JSON.stringify(section))
}

const LOADING_UPDATED = (state, bool = true) => {
  state.loading = bool
}

const SEARCH_UPDATED = (state, search = '') => {
  state.search = search
}

export default {
  TEMPLATES_UPDATED,
  TEMPLATE_UPDATED,
  PAGINATION_UPDATED,
  SECTIONS_UPDATED,
  SECTION_UPDATED,
  LOADING_UPDATED,
  SEARCH_UPDATED
}



// WEBPACK FOOTER //
// ./src/store/modules/templates/mutations.js